





























































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import cart from '@/store/modules/cart';
import { CartItem as CartItemModel } from '@/store/models';
import Login from '@/components/Checkout/UserStep/Login.vue';
import ForgotPassword from '@/components/Checkout/UserStep/ForgotPassword.vue';
import Registration from '@/components/Checkout/UserStep/Registration.vue';
import gtmhelpers from '@/commons/gtmhelpers';
import device from '@/store/modules/device';
import store from '@/store';
import BackButton from '@/components/UI/BackButton.vue';
import CmsBlock from '@/components/Cms/Block.vue';
import AdvantagesBlock from '@/components/Cms/AdvantagesBlock.vue';

@Component({
    components: {
        Login,
        ForgotPassword,
        Registration,
        BackButton,
        CmsBlock,
        AdvantagesBlock,
    },
})
export default class UserStep extends Vue {
    @Prop({ default: true }) public showBackButton!: boolean;
    @Prop({ default: false }) public showDefaultForm!: boolean;
    @Prop({ default: true }) public showRegistrationButton!: boolean;
    @Prop({ default: true }) public showLoginStepTitle!: boolean;
    public formVisible: string = '';

    get guestCheckout(): boolean {
        return store.state.options.guestCheckout;
    }

    get items(): CartItemModel[] {
        // get method si traduce in una computed
        return cart.cart.items;
    }

    get isMobile() {
        return device.isMobile;
    }

    public showLoginForm() {
        this.formVisible = 'login';
    }

    public showRegistrationForm() {
        this.formVisible = 'registration';
    }

    public goToCheckout() {
        this.$router.push({ path: '/checkout/shipping' });
    }

    public showForgotPasswordForm() {
        this.formVisible = 'forgot';
    }

    public clearUserStep() {
        this.formVisible = '';
    }

    @Watch('formVisible')
    public onFormChange() {
        this.$emit('formVisibleChange', this.formVisible);
    }

    private mounted() {
        gtmhelpers.trackPageview(this.$router.currentRoute.fullPath);
        device.updateMobileDetection();

        if (this.showDefaultForm) {
            this.showLoginForm();
        }
    }

    private created() {
        device.detectMobile();
    }
}
